// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Spread = require("./Spread.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var WindowUtils = require("../utils/WindowUtils.bs.js");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.bs.js");

function ctrlKey(prim) {
  return prim.ctrlKey;
}

function metaKey(prim) {
  return prim.metaKey;
}

function onConfirm(href, onClick, $$event) {
  $$event.preventDefault();
  Belt_Option.mapWithDefault(onClick, undefined, (function (onClick) {
          return Curry._1(onClick, $$event);
        }));
  return RescriptReactRouter.push(href);
}

function onCancel($$event) {
  $$event.preventDefault();
  
}

function handleOnClick(href, confirm, onClick, $$event) {
  var modifierPressed = $$event.ctrlKey || $$event.metaKey;
  if (modifierPressed) {
    return ;
  } else if (confirm !== undefined) {
    return WindowUtils.confirm((function (param) {
                  $$event.preventDefault();
                  
                }), confirm, (function (param) {
                  return onConfirm(href, onClick, $$event);
                }));
  } else {
    return onConfirm(href, onClick, $$event);
  }
}

function Link(Props) {
  var href = Props.href;
  var ariaLabel = Props.ariaLabel;
  var className = Props.className;
  var confirm = Props.confirm;
  var id = Props.id;
  var onClick = Props.onClick;
  var title = Props.title;
  var children = Props.children;
  var props = Props.props;
  var switchProps = Belt_Option.getWithDefault(props, {});
  var tmp = {
    href: href,
    onClick: (function (param) {
        return handleOnClick(href, confirm, onClick, param);
      })
  };
  if (ariaLabel !== undefined) {
    tmp["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement(Spread.make, {
              props: switchProps,
              children: React.createElement("a", tmp, children)
            });
}

var make = Link;

exports.ctrlKey = ctrlKey;
exports.metaKey = metaKey;
exports.onConfirm = onConfirm;
exports.onCancel = onCancel;
exports.handleOnClick = handleOnClick;
exports.make = make;
/* react Not a pure module */
